import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { useCaseListQuerySchema } from "@kansai-ai-hub/schema";

import { allMyApplicationsQueryOptions } from "@/features/applications/queries";
import { allMyBookmarksQueryOptions } from "@/features/bookmarks/queries";
import { MemberCasesPage } from "@/features/cases/member-cases-page";
import { casesListAllQueryOptions, toCaseListFilters } from "@/features/cases/queries";
import { companyOptionsQueryOptions } from "@/features/companies/queries";
import { memberProfileQueryOptions } from "@/features/member/queries";

const searchSchema = useCaseListQuerySchema.pick({
  q: true,
  industries: true,
  technologies: true,
  budgets: true,
  statuses: true,
  organizationNames: true,
  page: true,
  pageSize: true,
}).extend({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(12),
  view: z.enum(["grid", "table"]).default("grid"),
  // 応募状況フィルタ。view と同じくサーバーへ送らない UI 専用パラメータ。企業一覧と同仕様。
  applied: z.enum(["all", "applied", "not-applied"]).default("all"),
});

export const Route = createFileRoute("/_authenticated/member/")({
  validateSearch: searchSchema,
  // view / applied はサーバーへ送らない UI パラメータなので deps（= queryKey）から除外する
  loaderDeps: ({ search }) => toCaseListFilters(search),
  // ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
  // 一覧は全件取得してクライアント側でフィルタ＋ページネーションする（応募状況フィルタの
  // ページ分断を防ぐため）。page/pageSize は all-options 側で queryKey から除外される。
  loader: async ({ context, deps }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(casesListAllQueryOptions(deps)),
      context.queryClient.ensureQueryData(memberProfileQueryOptions()),
      // 応募済み/保存済みバッジ判定に使う自分の応募・保存を先読み（一覧本体と並行取得）。
      context.queryClient.ensureQueryData(allMyApplicationsQueryOptions()),
      context.queryClient.ensureQueryData(allMyBookmarksQueryOptions()),
      // 企業候補は任意データ。prefetch は非throw なので失敗しても一覧表示はブロックしない。
      context.queryClient.prefetchQuery(companyOptionsQueryOptions("cases")),
    ]);
  },
  component: MemberCasesPage,
});
